namespace RecordShield.Workspace {
    export class AnalyticsForm extends Serenity.PrefixedContext {
        static formKey = 'Workspace.Analytics';

    }

    export interface AnalyticsForm {
        AnalyticsId: Serenity.IntegerEditor;
        ActivationLogId: Serenity.IntegerEditor;
        ActivationId: Serenity.IntegerEditor;
        ProductId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        ProductItemId: Serenity.IntegerEditor;
        ContentKey: Serenity.IntegerEditor;
        StartedAt: Serenity.DateTimeEditor;
        EndedAt: Serenity.DateTimeEditor;
        WatchDurationInSeconds: Serenity.StringEditor;
        DeviceId: Serenity.StringEditor;
        DeviceType: Serenity.StringEditor;
        Sync: Serenity.BooleanEditor;
        SyncDate: Serenity.DateEditor;
    }

    [['AnalyticsId', () => Serenity.IntegerEditor], ['ActivationLogId', () => Serenity.IntegerEditor], ['ActivationId', () => Serenity.IntegerEditor], ['ProductId', () => Serenity.IntegerEditor], ['UserId', () => Serenity.IntegerEditor], ['ProductItemId', () => Serenity.IntegerEditor], ['ContentKey', () => Serenity.IntegerEditor], ['StartedAt', () => Serenity.DateTimeEditor], ['EndedAt', () => Serenity.DateTimeEditor], ['WatchDurationInSeconds', () => Serenity.StringEditor], ['DeviceId', () => Serenity.StringEditor], ['DeviceType', () => Serenity.StringEditor], ['Sync', () => Serenity.BooleanEditor], ['SyncDate', () => Serenity.DateEditor]].forEach(x => Object.defineProperty(AnalyticsForm.prototype, <string>x[0], { get: function () { return this.w(x[0], (x[1] as any)()); }, enumerable: true, configurable: true }));
}
